{
    "fl7LF7OMw": {
        "key": "fl7LF7OMw",
        "position": {
            "x": 20,
            "y": 23,
            "z": 1
        },
        "direction": {
            "x": -1
        },
        "tag": "spawn-knight"
    },
    "Vh79rbTpgmnroU8xBAbwb": {
        "position": {
            "x": 19,
            "y": 24,
            "z": 1
        },
        "direction": {
            "x": -2
        },
        "key": "Vh79rbTpgmnroU8xBAbwb",
        "tag": "spawn-bard"
    },
    "Ngjw_HGS218ou2FBSmxTJ": {
        "position": {
            "x": 10,
            "y": 25,
            "z": 1
        },
        "key": "Ngjw_HGS218ou2FBSmxTJ",
        "tag": "spawn"
    },
    "do7Ya5XJ5UmRr7MyH8-FU": {
        "position": {
            "x": 11,
            "y": 25,
            "z": 1
        },
        "key": "do7Ya5XJ5UmRr7MyH8-FU",
        "tag": "spawn"
    },
    "H2yByjxaXOG-5jqzltcRI": {
        "position": {
            "x": 11,
            "y": 26,
            "z": 1
        },
        "key": "H2yByjxaXOG-5jqzltcRI",
        "tag": "spawn"
    },
    "OEdIkD6sLkuOyXjWRVMhu": {
        "position": {
            "x": 10,
            "y": 26,
            "z": 1
        },
        "key": "OEdIkD6sLkuOyXjWRVMhu",
        "tag": "spawn"
    },
    "Hnb2WiC2F": {
        "key": "Hnb2WiC2F",
        "position": {
            "x": 16,
            "y": 23,
            "z": 1
        }
    },
    "uKSBYZyznL": {
        "key": "uKSBYZyznL",
        "position": {
            "x": 16,
            "y": 24,
            "z": 1
        }
    },
    "0FiFyFMeT": {
        "key": "0FiFyFMeT",
        "position": {
            "x": 17,
            "y": 24,
            "z": 1
        }
    },
    "ysR4RFer4": {
        "key": "ysR4RFer4",
        "position": {
            "x": 14,
            "y": 18,
            "z": 1
        }
    },
    "eSUxlgIgC0": {
        "key": "eSUxlgIgC0",
        "position": {
            "x": 14,
            "y": 17,
            "z": 1
        }
    },
    "r3Adbj-Pch": {
        "key": "r3Adbj-Pch",
        "position": {
            "x": 15,
            "y": 17,
            "z": 1
        }
    },
    "5yarueq6Z": {
        "key": "5yarueq6Z",
        "position": {
            "x": 15,
            "y": 18,
            "z": 1
        }
    },
    "mdmBujtHa": {
        "key": "mdmBujtHa",
        "position": {
            "x": 21,
            "y": 14,
            "z": 1
        }
    },
    "vhsL9d0wcA": {
        "key": "vhsL9d0wcA",
        "position": {
            "x": 20,
            "y": 13,
            "z": 1
        }
    },
    "i2X-Gr2DDq": {
        "key": "i2X-Gr2DDq",
        "position": {
            "x": 21,
            "y": 13,
            "z": 1
        }
    },
    "BQ6nvtHQ6": {
        "key": "BQ6nvtHQ6",
        "position": {
            "x": 20,
            "y": 14,
            "z": 1
        }
    },
    "vPFKbmGA8": {
        "key": "vPFKbmGA8",
        "position": {
            "x": 16,
            "y": 18,
            "z": 1
        }
    },
    "DC1M_cNhw": {
        "key": "DC1M_cNhw",
        "position": {
            "x": 14,
            "y": 16,
            "z": 1
        }
    },
    "mpE0lBhuJ": {
        "key": "mpE0lBhuJ",
        "position": {
            "x": 22,
            "y": 14,
            "z": 1
        }
    },
    "ZT33Dps6pN": {
        "key": "ZT33Dps6pN",
        "position": {
            "x": 20,
            "y": 12,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "jFWA-NosQ_2ABeWRjH86s": {
        "position": {
            "x": 22,
            "y": 14,
            "z": 1
        },
        "direction": {
            "y": -1
        },
        "key": "jFWA-NosQ_2ABeWRjH86s",
        "tag": "spawn-bad"
    },
    "Z_Ho837U6XsCsT7YgdfIm": {
        "position": {
            "x": 21,
            "y": 10,
            "z": 1
        },
        "direction": {
            "y": 1
        },
        "key": "Z_Ho837U6XsCsT7YgdfIm",
        "tag": "spawn-bad"
    }
}